import { useMemo } from "react";
import type { FieldValues } from "react-hook-form";
import type { ValidationError } from "yup";

import type { UnitLevelCoverages } from "@covertree/new-business-graphql";
import {
  policyCustomizationValidations,
  type ValidationKey,
} from "@covertree/new-business-forms";
import type { CoverageRules } from "@covertree/new-business-policy-customization";

import { NO_POLICY_LEVEL_COVERAGES } from "./constants";

/** The form has no resolver on this step, so validation goes through field rules. */
export const useCoverageRules = (
  keys: ValidationKey[],
  base?: UnitLevelCoverages
) =>
  useMemo<CoverageRules>(() => {
    if (!base) return {};

    const schema = policyCustomizationValidations(
      NO_POLICY_LEVEL_COVERAGES,
      base
    );

    const validate =
      (key: ValidationKey) => (_: unknown, values: FieldValues) => {
        try {
          schema.validateSyncAt(`units[0].unitLevelCoverages.${key}`, values);
          return true;
        } catch (error) {
          return (error as ValidationError).message;
        }
      };

    return Object.fromEntries(
      keys.map((key) => [key, { validate: validate(key) }])
    );
  }, [base, keys]);
